import { Button, Container, Text, Title } from "@mantine/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { selectSuccessContent } from "../../../redux/selectors/publicSelector";
import { useSelector } from "react-redux";
import colors from "../../../utils/styles";

const BookingSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('bookingId');
  const content = useSelector(selectSuccessContent);

  return <Container size="responsive"
    styles={{
      root: {
        background: 'linear-gradient(180deg,#67bae7,#32549b 33%,#32549b 66%,#67bae7)',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }
    }}>
    <div style={{
      borderRadius: '10px',
      border: colors.appBorder,
      padding: '40px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Title style={{
        fontWeight: 900,
        color: colors.appYellow,
        fontSize: '34px',
        marginBottom: 'md',
      }}>{content.title}
      </Title>
      <Text styles={{
        root: {
          fontSize: '18px',
          color: colors.appWhite,
          textAlign: 'center',
        }
      }}>
        {content.welcome}
      </Text>
      {bookingId && <Text styles={{
        root: {
          fontSize: '18px',
          color: colors.appWhite,
          textAlign: 'center',
        }
      }}>
        {content.bookingId} <span style={{ fontWeight: 900, color: colors.appYellow, fontSize: '22px' }}>{bookingId}</span>
      </Text>}
      <Text styles={{
        root: {
          fontSize: '18px',
          color: colors.appWhite,
          textAlign: 'center',
        }
      }}>
        {content.emailConfirmation}
      </Text>
      <Button
        style={{ backgroundColor: colors.appPink, boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.5)' }}
        onClick={() => navigate('/')} radius="xl" size="md" mt="xl">
        {content.backToHome}
      </Button>
    </div>

  </Container>;
};

export default BookingSuccess;
